import Vue from 'vue'

export default Vue.extend({
  template: `
    <div class="class-actions-renderer">
      <span
          v-b-tooltip title="Редактировать"
          class="adminAction fas fa-edit text-primary text-center"
          :style="{cursor: cursorStyle}"
          @click="onEditClicked"
      ></span>
    </div>
  `,
  data() {
    return {
      cursorStyle: 'pointer'
    }
  },
  computed: {
  },
  methods: {
    onEditClicked() {
      this.params.context.componentParent.onParentEditClicked(this.params.node.data)
    }
  }
})
